import { useTranslation } from "@redotech/redo-i18n";

export const DEFAULT_ADDRESS_SCREEN_TITLE = "Confirm address";
export const DEFAULT_ADDRESS_SCREEN_SUBTITLE =
  "Make sure the information below is correct.";
export const DEFAULT_RETURNING_ITEMS_FROM_TITLE = "Returning items from:";
export const DEFAULT_SHIPPING_NEW_ITEMS_TO_TITLE = "Shipping new items to:";
export const DEFAULT_YOUR_ADDRESS_TITLE = "Your address:";
export const DEFAULT_SAME_AS_RETURNING_ITEMS_FROM_TEXT =
  "Same as returning items from.";
export const DEFAULT_EDIT_ADDRESS_TITLE = "Edit address";

export function getDefaultAddressSectionTitle({
  hasNonGreenReturnItems,
  showNewItems,
}: {
  hasNonGreenReturnItems: boolean;
  showNewItems: boolean;
}) {
  if (hasNonGreenReturnItems) {
    return DEFAULT_RETURNING_ITEMS_FROM_TITLE;
  }
  if (showNewItems) {
    return DEFAULT_SHIPPING_NEW_ITEMS_TO_TITLE;
  }
  return DEFAULT_YOUR_ADDRESS_TITLE;
}

export function useDefaultAddressCopy() {
  const { t } = useTranslation();

  return {
    addressScreenTitle: t("Confirm address"),
    addressScreenSubtitle: t("Make sure the information below is correct."),
    shippingNewItemsToTitle: t("Shipping new items to:"),
    sameAsReturningItemsFromText: t("Same as returning items from."),
    getAddressSectionTitle: (params: {
      hasNonGreenReturnItems: boolean;
      showNewItems: boolean;
    }) => {
      const defaultTitle = getDefaultAddressSectionTitle(params);
      switch (defaultTitle) {
        case DEFAULT_RETURNING_ITEMS_FROM_TITLE:
          return t("Returning items from:");
        case DEFAULT_SHIPPING_NEW_ITEMS_TO_TITLE:
          return t("Shipping new items to:");
        case DEFAULT_YOUR_ADDRESS_TITLE:
          return t("Your address:");
      }
    },
  };
}
